import React from 'react'
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap'
import root from '../shared/utils'
import { createSeasonalCustomOrder, acceptProposal } from '../api'
import { getUpSellIconType } from '../shared/enums/upsell-icon-type'
import { getTaskTypeIconParser } from '../shared/enums/task-type-icon-parser'

let imgSrc = root + '/common/latest/images/consumer/credit-card-icons/'
let visa = imgSrc + 'Visa.png'
let mastercard = imgSrc + 'Mastercard.png'
let amex = imgSrc + 'Amex.png'
let discover = imgSrc + 'Discover.png'
let formattedExp = false
let orderSpinner = root + '/common/latest/images/play/white-lawnmowing-guy.gif'

// Always shown instead of the raw server body. The backend is Play: an
// unhandled exception returns HTML carrying the exception class, source path
// and line, and a constraint violation surfaces SQL. api.js already logs the
// real response for debugging.
const ORDER_ERROR_MESSAGE = 'There was an error processing your payment. Please try again later.'

const OrderPaymentModal = React.createClass({
  getInitialState: function () {
    return {
      paymentArea: '',
      newCard: false,
      name: '',
      billingAddress: '',
      zipcode: '',
      ccNumber: '',
      expDate: '',
      cvvCode: '',
      profileId: '',
      cost: '',
      submitting: false
    }
  },
  handleInputChange: function (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    if (name === 'expDate') {
      // ([0-9]{2}[/][0-9]{2})
      let matchingInts = value.match(/[0-9]*[/]?[0-9]*/)
      if (value.length <= 5) {
        if (value.length === 2 && formattedExp !== true) {
          this.setState({[name]: matchingInts[0] + '/'})
          formattedExp = true
        } else {
          this.setState({[name]: matchingInts[0]})
          formattedExp = false
        }
      }
    } else if (name === 'ccNumber') {
      if (value.length <= 16) {
        let matchingInts = value.match(/([0-9]*)/)
        this.setState({[name]: matchingInts[0]})
      }
    } else if (name === 'cvvCode') {
      let matchingInts = value.match(/([0-9]*)/)
      if (matchingInts[0].length <= 4) {
        this.setState({[name]: matchingInts[0]})
      }
    } else {
      this.setState({[name]: value})
    }
  },
  formatExpDate: function (type) {
    let splitDate = this.state.expDate.split('/')
    if (type === 'month') {
      return splitDate[0]
    } else {
      return '20' + splitDate[1]
    }
  },
  componentWillReceiveProps: function (nextProps) {
    // Recovery net for a request that never settles. Guarded on the show
    // transition because this fires on every parent render, and on _inFlight so
    // reopening can never re-arm a request that is still running (that would
    // recreate the very duplicate-order hole this ticket closes). Truthiness
    // rather than === false: account.jsx does not initialise the flag, so
    // `show` is undefined there before the first open.
    if (!this.props.show && nextProps.show && !this._inFlight) {
      this.setState({submitting: false})
    }
    this.setState({comment: nextProps.comment})
    if (nextProps.modalProps.modalCard) {
      this.setState({cost: nextProps.modalProps.modalCard.cost})
    } else {
      this.setState({cost: nextProps.taskData.price})
    }
    if (this.props.login.customer.paymentProfile) {
      let paymentPojo = this.props.login.customer.paymentProfile
      this.setState({
        name: paymentPojo.billingName,
        billingAddress: paymentPojo.billingAddress,
        zipCode: paymentPojo.zipCode,
        ccNumber: paymentPojo.billingCardNumber,
        profileId: paymentPojo.profileId
      })
    }
  },
  // Clears the in-flight latch. MUST run before any props callback below:
  // setState from a promise callback is not batched in React 15, so this
  // commits synchronously, and React 15 has no error boundaries. If a callback
  // throws, the button is already re-enabled. Do not reorder.
  finishSubmit: function () {
    this._inFlight = false
    // Card fields are cleared here as well as in closeModal, because the
    // success path calls props.hide() directly and never runs closeModal. The
    // modal is mounted unconditionally and never unmounts, so without this the
    // card number and CVV would stay in state for the rest of the session.
    this.setState({submitting: false, ccNumber: '', expDate: '', cvvCode: ''})
  },
  handleOrderResponse: function (data) {
    this.finishSubmit()
    if (data && data.data && data.data.taskId !== undefined) {
      this.props.hide()
      this.props.openConfirmation(data.data.taskId, this.props.taskData.price)
    } else {
      this.props.openNotificationModal('order-payment-modal', 'Processing Error', ORDER_ERROR_MESSAGE)
    }
  },
  handleProposalResponse: function (data) {
    this.finishSubmit()
    if (data === 'okay') {
      this.props.hide()
      this.props.openConfirmation(this.props.modalProps.modalCard.mobileTask.taskId, this.props.taskData.price)
    } else {
      this.props.openNotificationModal('order-payment-modal', 'Processing Error', ORDER_ERROR_MESSAGE)
    }
  },
  handleOrderFailure: function () {
    this.finishSubmit()
  },
  createOrder: function () {
    // The real duplicate-order barrier. `disabled` is only the visual signal:
    // React 15 flushes the setState batch at the end of each event dispatch, so
    // a second click reads the committed flag.
    if (this.state.submitting || this._inFlight) {
      return
    }

    // Every argument is resolved BEFORE the latch is armed. A throw in any of
    // these expressions (an absent mobileTask, say) would otherwise leave the
    // latch set with no promise to clear it, killing the button for the session.
    const {serviceStartDate} = this.props.taskData
    let comment = this.state.comment
    let taskType
    if (this.props.modalProps.card) {
      taskType = getUpSellIconType(this.props.modalProps.card.upSellType)
      taskType = getTaskTypeIconParser(taskType.prettify).apiName
    } else if (this.props.modalProps.modalCard) {
      taskType = this.props.modalProps.modalCard.taskType
    }

    let displayAddress = this.props.modalProps.address
    if (this.props.newAddress) {
      displayAddress = this.props.newAddress
    }

    // Only `newCard === false && proposed === true` accepts a proposal; every
    // other combination creates a seasonal task. The two branches that did the
    // latter were byte-identical, so they collapse with no behaviour change.
    const acceptingProposal = this.state.newCard === false && this.props.modalProps.proposed === true
    let customerId, proposalTaskId
    if (acceptingProposal) {
      customerId = this.props.login.customer.customerId
      proposalTaskId = this.props.modalProps.modalCard.mobileTask.taskId
    }

    this._inFlight = true
    this.setState({submitting: true})

    try {
      if (acceptingProposal) {
        acceptProposal(customerId, proposalTaskId)
          .then(this.handleProposalResponse)
          .catch(this.handleOrderFailure)
      } else {
        createSeasonalCustomOrder(taskType, displayAddress, serviceStartDate, comment)
          .then(this.handleOrderResponse)
          .catch(this.handleOrderFailure)
      }
    } catch (e) {
      this.finishSubmit()
      throw e
    }
  },
  closeModal: function () {
    let paymentInfo = this.props.login.customer.paymentProfile
    this.setState({
      billingAddress: paymentInfo.billingAddress,
      name: paymentInfo.billingName,
      zipcode: paymentInfo.billingZip,
      ccNumber: '',
      expDate: '',
      cvvCode: ''
    })
    this.props.hide()
  },
  showPayment: function () {
    if (document.getElementById('display') !== null) {
      let paymentInfo = this.props.login.customer.paymentProfile
      this.setState({
        billingAddress: paymentInfo.billingAddress,
        name: paymentInfo.billingName,
        zipcode: paymentInfo.billingZip,
        ccNumber: ''
      })
      document.getElementById('display').classList.add('hide')
      document.getElementById('payment').classList.remove('hide')
      this.setState({newCard: true})
    } else {
    }
  },
  render: function () {
    let taskType = 'AERATELAWN'
    if (this.props.modalProps.card) {
      taskType = getUpSellIconType(this.props.modalProps.card.upSellType)
      taskType = getTaskTypeIconParser(taskType.prettify).apiName
    } else if (this.props.modalProps.modalCard) {
      taskType = this.props.modalProps.modalCard.taskType
    }

    let color, newTitle

    color = getTaskTypeIconParser(taskType).iconsrc + '-background'
    newTitle = getTaskTypeIconParser(taskType).prettify

    let displayAddress = this.props.modalProps.streetAddress
    if (this.props.displayAddress) {
      displayAddress = this.props.displayAddress.streetAddress
    }

    return (
      <div style={{zIndex: '5002'}}>
        <Modal show={this.props.show} onHide={this.closeModal} dialogClassName='upsell-modal-size'>
          <div className='white-background'>
            <Modal.Header closeButton>
              <div className='col-xs-1' />
              <div className='center-block col-xs-10'>
                <h2 className='text-center pull-down-xs-2'>Payment Info</h2>
                <br />
                <form>
                  <div id='display' style={{textAlign: 'center'}}>
                    <p>Pay with card ending in {this.state.ccNumber}</p>
                    <a style={{textDecoration: 'underline', position: 'relative', top: -10}} onClick={this.showPayment}>Change
                      payment info</a>
                  </div>
                  <div id='payment' className='hide'>
                    <FormGroup bsClass='form-group' className={this.state.name ? 'has-value' : ''}>
                      <ControlLabel>Name of Card Holder</ControlLabel>
                      <FormControl value={this.state.name} type='text' name='name' onChange={this.handleInputChange} />
                    </FormGroup>
                    <FormGroup bsClass='form-group' className={this.state.billingAddress ? 'has-value' : ''}>
                      <ControlLabel>Billing Address</ControlLabel>
                      <FormControl value={this.state.billingAddress} type='text' name='billingAddress'
                        onChange={this.handleInputChange} />
                    </FormGroup>
                    <div className='row'>
                      <div className='col-xs-6'>
                        <FormGroup bsClass='form-group' className={this.state.zipcode ? 'has-value' : ''}>
                          <ControlLabel>Zip Code</ControlLabel>
                          <FormControl value={this.state.zipcode} type='text' name='zipcode'
                            onChange={this.handleInputChange} />
                        </FormGroup>
                      </div>
                    </div>
                    <div className='well well-lg pull-down-xs-2' style={{backgroundColor: '#d6eac1'}}>
                      <FormGroup className={this.state.ccNumber ? 'has-value' : ''}>
                        <ControlLabel>Credit Card Number</ControlLabel>
                        <FormControl name='ccNumber' value={this.state.ccNumber} onChange={this.handleInputChange} />
                      </FormGroup>
                      <div className='row'>
                        <div className='col-xs-6'>
                          <FormGroup className={this.state.expDate ? 'has-value' : ''}>
                            <ControlLabel>Exp Date</ControlLabel>
                            <FormControl value={this.state.expDate} name='expDate' onChange={this.handleInputChange} />
                          </FormGroup>
                        </div>
                        <div className='col-xs-6'>
                          <FormGroup className={this.state.cvvCode ? 'has-value' : ''}>
                            <ControlLabel>CVV Code</ControlLabel>
                            <FormControl value={this.state.cvvCode} name='cvvCode' onChange={this.handleInputChange} />
                          </FormGroup>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-xs-2' />
                        <div className='col-xs-8 text-center'>
                          <img src={visa} alt='visa icon' style={{padding: '0 8px 0 5px'}} />
                          <img src={mastercard} alt='mastercard icon' style={{padding: '0 5px 0 5px'}} />
                          <img src={discover} alt='discover icon' style={{padding: '0 5px 0 5px'}} />
                          <img src={amex} alt='amex icon' style={{padding: '0 5px 0 5px'}} />
                        </div>
                        <div className='col-xs-2' />
                      </div>
                      <div className='row'>
                        <div className='col-xs-1'>
                          <i className='fa fa-lock fa-lg' aria-hidden='true' style={{paddingLeft: '10px'}} />
                        </div>
                        <div className='col-xs-11'>
                          <span className='small'><small>Your account information is protected by industry certified 256-bit encryption and is protected against theft and fraud.</small></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <FormGroup>
                    <h5 className='text-center pull-down-xs-2'>Your {newTitle} summary:</h5>
                    <div className={color + ' upsell-box'}>
                      <span style={{fontWeight: 100}}><b>{newTitle}</b> for <br /> {displayAddress}</span>
                      <hr />
                      <span style={{fontWeight: 100}}><b style={{fontSize: 46}}>${this.state.cost}</b>/service</span>
                      <br />
                      <span>{this.props.taskData.interval} {newTitle}</span>
                    </div>
                    <Button type='button' bsClass='btn btn-success btn-sm center-block' onClick={this.createOrder} disabled={this.state.submitting}>
                      {this.state.submitting ? 'Placing Order...' : 'Place Order'}
                    </Button>
                    {/* role='status' carries the accessibility signal, not the
                        label swap: disabling the button blurs it to <body>, and
                        an accessible-name change is only announced for the
                        focused element. Fixed height so the modal does not
                        reflow under the user's cursor mid-interaction. */}
                    <div role='status' className='text-center' style={{minHeight: 72, marginTop: 10}}>
                      {this.state.submitting
                        ? <div style={{backgroundColor: 'rgba(92, 184, 92, 0.85)', borderRadius: 4, display: 'inline-block', padding: '4px 12px'}}>
                          <img src={orderSpinner} alt='Placing your order' className='img-responsive center-block' style={{maxHeight: 64}} />
                        </div>
                        : null}
                    </div>
                    <p style={{marginTop: 20, textAlign: 'center', fontSize: 13}}>By clicking this button, you agree to
                      our Conditions of Use and your account will be charged the above deposit amount for your
                      service.</p>
                    {/* <a href=''>Save for later</a> */}
                  </FormGroup>
                </form>
              </div>
            </Modal.Header>
          </div>
        </Modal>
      </div>
    )
  }
})

export default OrderPaymentModal



// WEBPACK FOOTER //
// ./src/components/modals/order-payment-modal.jsx